import emitter from '../utils/emitter'

export function readDialogError(err, fallback = 'Something went wrong.') {
  if (typeof err === 'string') {
    const trimmed = err.trim()
    if (!trimmed) return fallback
    if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
      try {
        const parsed = JSON.parse(trimmed)
        return parsed.error || parsed.message || trimmed
      } catch {}
    }
    return trimmed
  }
  const data = err?.response?.data ?? err
  if (data == null) return err?.message || fallback
  if (typeof data === 'string') return readDialogError(data, fallback)
  if (typeof data === 'object') return data.error || data.message || fallback
  return fallback
}

export function notifyDialog(payload) {
  const next = typeof payload === 'string' ? { message: payload } : payload || {}
  emitter.emit('dialog-notify', next)
}

export function notifyDialogError(err, fallback = 'Something went wrong.') {
  notifyDialog({
    type: 'error',
    title: 'Error',
    message: readDialogError(err, fallback),
  })
}
